// extracted by mini-css-extract-plugin
export default {"breadcrumb_item":"Breadcrumb_breadcrumb_item__d9cPT"};